module.exports = __webpack_public_path__ + "img/sky.0dbedac2.png";